export default {
  // 下面是正则表达式集合
  inputRegexpCollection: {
    emailReg: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // 邮箱正则校验，只校验中间有@且以.*结尾
    idCardReg: /(^\d{15}$)|(^\d{17}(\d|X)$)/, // 身份证简单校验，只校验是否为18位或15位数字
    cn: /^[\u4e00-\u9fa5]+$/, // 中文
    en: /^[a-zA-Z ]+$/, // 英文
    enLetter: /^[a-zA-Z]+$/, // 英文字母
    phone: /^1\d{10}$/, // 手机号
    passport: /^[A-Z0-9]{5,12}$/, // 护照号
    number: /^\d+$/,
    any: /.+/, // 任意字符
    amount: /(^\d+$)|(^\d+\.\d{1,2}$)/, // 金额
  },

  required(msg) {
    return { required: true, message: `请输入${msg || '内容'}`, trigger: 'blur' };
  },
  // 未填写
  requiredRadio(msg) {
    return { required: true, message: `请选择${msg || '内容'}`, trigger: 'blur' };
  },
  mobile(msg) {
    return { pattern: /^1\d{10}$/, message: `请输入正确的${msg || '手机号'}`, trigger: 'blur' };
  },
  int(msg) {
    return { pattern: /^\d+$/, message: `请输入正确的${msg || '内容'}`, trigger: 'blur' };
  },
  email(msg) {
    return { type: 'email', message: `请输入正确的${msg || '内容'}`, trigger: 'blur' };
  },
  date(msg) {
    return { required: true, type: 'date', message: `请输入正确的${msg || '内容'}`, trigger: 'change' };
  },
  range(max, min, msg) {
    return { max, min, message: `请输入正确位数的${msg || '内容'}`, trigger: 'blur' };
  },
  common(msg) {
    return { pattern: /^[\u4e00-\u9fa5a-z A-Z0-9]+$/, message: `请输入正确的${msg || '内容'}`, trigger: 'blur' };
  },
  chn(msg) {
    return { pattern: /^[\u4e00-\u9fa5]+$/, message: `请输入正确的${msg || '内容'}`, trigger: 'blur' };
  },
  linkName(msg) {
    return { pattern: /^[ a-zA-Z\u4e00-\u9fa5]+$/, message: `请输入正确的${msg || '内容'}`, trigger: 'blur' };
  },
  // 保险使用的正则表达式集合
  insuranceRegCollection: {
    // 未填写
    required(msg) {
      return { required: true, message: `请输入${msg || '内容'}`, trigger: 'blur' };
    },
    // 中文姓名
    cname(msg) {
      return { pattern: /^[\u4e00-\u9fa5]+$/, message: `请输入正确的${msg || '中文姓名'}`, trigger: 'blur' };
    },
    // 姓名拼音
    ename(msg) {
      return { pattern: /^[a-z\sA-Z]+$/, message: `请输入正确的${msg || '姓名拼音'}`, trigger: 'blur' };
    },
    // 电子邮箱
    email(msg) {
      return { pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: `请输入正确的${msg || '电子邮箱'}`, trigger: 'blur' };
    },
    // 手机号码
    mobile(msg) {
      return { pattern: /^1\d{10}$/, message: `请输入正确的${msg || '手机号码'}`, trigger: 'blur' };
    },
    // 日期
    date(msg) {
      return { type: 'date', required: true, message: `请选择${msg || '日期'}`, trigger: 'change,blur' };
    },
    // radio类型的表单元素，值为数字类型
    radio(msg) {
      return { type: 'number', required: true, message: `请选择${msg || '内容'}`, trigger: 'change' };
    },
    // 护照
    passport(msg) {
      return { pattern: /^[a-zA-Z0-9]+$/, message: `请输入正确的${msg || '证件号码'}`, trigger: 'blur' };
    },
    // 被保人姓名
    insurantsName(msg) {
      return { pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/, message: `请输入正确的${msg || '姓名'}`, trigger: 'blur' };
    },
    // 公司名称
    companyName(msg) {
      return { pattern: /^[\u4e00-\u9fa5（）()]+$/, message: `请输入正确的${msg || '中文姓名'}`, trigger: 'blur' };
    },
    // 公司拼音
    companyEname(msg) {
      return { pattern: /^[a-zA-Z]+$/, message: `请输入正确的${msg || '拼音'}`, trigger: 'blur' };
    },
    // 统一社会信用代码
    creditCode(msg) {
      return { pattern: /^[A-Z0-9]+$/, message: `请输入正确的${msg || '统一社会信用代码'}`, trigger: 'blur' };
    },
  },
};



// WEBPACK FOOTER //
// ./src/libs/validates.js